import { Component, Input, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-minimal-table',
  templateUrl: './minimal-table.component.html',
  styleUrls: ['./minimal-table.component.scss']
})
export class MinimalTableComponent implements OnInit {
  @Input() dataSource;
  @Input() columns;

  constructor() { }

  ngOnInit(): void {
  }

  public onSortData(sort: Sort) {
    // this.store$.dispatch(CountsActions.loadFinancial({ invID: this.inventory.invID, active: sort.active, direction: sort.direction }))
  }

  public compare(a: number | string, b: number |  string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }


}
